import { render, staticRenderFns } from "./AsnDetailList.vue?vue&type=template&id=1a62d29d"
import script from "./AsnDetailList.vue?vue&type=script&lang=js"
export * from "./AsnDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports